var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.nama))])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("\n                            " + _vm._s(_vm.id_informasi_kegiatan != null ? 'Edit' : 'Tambah') + " " + _vm._s(_vm.nama) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form-line', {
    attrs: {
      "id": "judul",
      "type": "text"
    },
    model: {
      value: (_vm.content.judul),
      callback: function($$v) {
        _vm.$set(_vm.content, "judul", $$v)
      },
      expression: "content.judul"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-line"
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "tanggal",
      "config": _vm.date
    },
    model: {
      value: (_vm.tanggal),
      callback: function($$v) {
        _vm.tanggal = $$v
      },
      expression: "tanggal"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('Ckeditor', {
    attrs: {
      "id": "deskripsi",
      "config": _vm.config
    },
    model: {
      value: (_vm.content.deskripsi),
      callback: function($$v) {
        _vm.$set(_vm.content, "deskripsi", $$v)
      },
      expression: "content.deskripsi"
    }
  })], 1)])]), _vm._v(" "), (_vm.id_informasi_kegiatan) ? _c('div', {
    staticClass: "row clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sm-8 col-xs-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-dropzone', {
    ref: "myVueDropzone",
    attrs: {
      "id": "dropzone",
      "destroyDropzone": false,
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-removed-file": _vm.vremoved,
      "vdropzone-sending": _vm.sendingEvent
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"
  }, [(_vm.id_informasi_kegiatan != null) ? _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-warning waves-effect waves-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.update
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), (!_vm.isLoading) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]) : _vm._e(), _vm._v(" Edit")]) : _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-primary waves-effect waves-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.save
    }
  }, [(_vm.isLoading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), (!_vm.isLoading) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("save")]) : _vm._e(), _vm._v(" Simpan")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "waves",
      rawName: "v-waves.button",
      modifiers: {
        "button": true
      }
    }],
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")]), _vm._v(" Batal")])])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "judul"
    }
  }, [_vm._v("Judul")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "tanggal"
    }
  }, [_vm._v("Tanggal")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "deskripsi"
    }
  }, [_vm._v("Deskripsi")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"
  }, [_c('label', {
    attrs: {
      "for": "deskripsi"
    }
  }, [_vm._v("Foto Kegiatan")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec8b41a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Informasi/Kegiatan/FormKegiatan.vue
// module id = TBIn
// module chunks = 1